import React, { useState } from "react";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import FormLabel from "@mui/material/FormLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import SuiButton from "components/SuiButton";

const OptionItem = styled("li")(({ theme, selected }) => ({
  '&&[aria-selected="true"]': {
    backgroundColor: "#1264e2 !important",
    color: "white !important",
    "&:hover": {
      backgroundColor: "#1264e2 !important",
      color: "white !important",
    },
  },
  "&.Mui-focused": {
    backgroundColor: selected ? "#1264e2 !important" : "inherit",
    color: selected ? "white !important" : "inherit",
  },
}));

const SubServiceDropdown = ({
  options = [],
  value = [],
  onChange,
  onClickAddNewSubservice,
  label = "Select services",
  placeholder = "Search for services...",
  className = "",
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event, newValue) => {
    setInputValue(newValue || "");
  };

  const handleAddNew = () => {
    if (inputValue.trim() !== "") {
      const newOption = {
        id: `new-${Date.now()}`,
        label: inputValue,
        parentServiceId: null,
      };

      if (onClickAddNewSubservice) {
        onClickAddNewSubservice(newOption);
      }

      setInputValue("");
    }
  };

  return (
    <>
      <FormLabel
        sx={{
          color: "#000000",
          "&.Mui-focused": {
            color: "#000000 !important",
          },
        }}
      >
        {label}
      </FormLabel>
      <Autocomplete
        multiple
        disableCloseOnSelect
        value={value}
        onChange={(event, newValues) => onChange && onChange(newValues)}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        options={options}
        getOptionLabel={(option) => option.label}
        className={className}
        popupIcon={<ExpandMoreIcon fontSize="small" />}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant="outlined"
            fullWidth
            sx={{
              "& .MuiInputBase-root": {
                padding: "0 !important",
              },
            }}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <OptionItem
            {...props}
            key={option.id}
            selected={selected}
            sx={{
              '&[aria-selected="true"]': {
                backgroundColor: "#1264e2 !important",
                color: "white !important",
              },
              fontWeight: selected ? 600 : 400,
            }}
          >
            {option.label}
          </OptionItem>
        )}
        sx={{
          padding: 0,
          '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: "#1264e2 !important",
            color: "white !important",
          },
        }}
        renderTags={() => null}
        noOptionsText={
          inputValue.trim() !== "" ? (
            <Box sx={{ p: 1, textAlign: "center" }}>
              <Typography
                color="text.secondary"
                sx={{ mb: 1, fontSize: "14px" }}
              >
                No matches for "{inputValue}"
              </Typography>
              <SuiButton
                onClick={handleAddNew}
                buttonColor="info"
                size="small"
                fullWidth
              >
                + Create a new service: "{inputValue}"
              </SuiButton>
            </Box>
          ) : (
            <Box sx={{ p: 1, textAlign: "center" }}>NO DATA</Box>
          )
        }
        filterOptions={(options, { inputValue }) =>
          options.filter((option) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
          )
        }
        isOptionEqualToValue={(option, value) => {
          return option.id === value.id || option.label === value.label;
        }}
      />
    </>
  );
};

export default SubServiceDropdown;
